import { render, staticRenderFns } from "./Responsive.vue?vue&type=template&id=d4bf14ba&scoped=true&lang=pug&"
import script from "./Responsive.vue?vue&type=script&lang=js&"
export * from "./Responsive.vue?vue&type=script&lang=js&"
import style0 from "./Responsive.vue?vue&type=style&index=0&id=d4bf14ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf14ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
